import clsx from "clsx";
import React from "react";
export default function PromoBanner(param) {
    var title = param.title, target = param.target, subtitle = param.subtitle, type = param.type, color = param.color;
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-white shadow-[0_2px_10px_0_rgba(0,0,0,0.1)] relative"
    }, /*#__PURE__*/ React.createElement("a", {
        href: target,
        className: "group block no-underline lg:flex focus lg:gap-x-6 items-start pt-4 pl-5 min-h-[100px] overflow-hidden"
    }, /*#__PURE__*/ React.createElement("span", {
        className: clsx("rounded-full inline-block mb-3 lg:mb-0 py-1 px-2.5 mt-0.5 uppercase text-[9px] font-heading font-semibold tracking-wider", {
            "text-orange-500 bg-orange-100": color !== "yellow",
            "text-black-600 bg-yellow-100": color === "yellow"
        })
    }, type), /*#__PURE__*/ React.createElement("div", {
        className: "pb-24 md:pb-6 lg:pb-5 pr-5 md:pr-32 lg:pr-28"
    }, /*#__PURE__*/ React.createElement("h4", {
        className: "font-heading font-semibold text-lg leading-tight mb-0.5 mt-0"
    }, title), /*#__PURE__*/ React.createElement("p", {
        className: "text-gray-100 text-sm font-semibold"
    }, subtitle)), /*#__PURE__*/ React.createElement("div", {
        className: "overflow-hidden absolute bottom-0 md:bottom-[unset] md:top-0 right-0 h-full w-24 md:w-32 lg:w-24"
    }, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 111 118",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: clsx("absolute -bottom-3 md:bottom-[unset] md:top-0 right-0 h-[104px] md:h-full lg:h-[104px] rotate-90 md:rotate-0 w-auto transition-all", {
            "text-orange-500 group-hover:text-orange-600": color !== "yellow",
            "text-yellow-500 group-hover:text-yellow-600": color === "yellow"
        })
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-594.000000, -537.000000)",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Promo-Banner",
        transform: "translate(75.000000, 437.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link-Tab",
        transform: "translate(519.000000, -0.000000)"
    }, /*#__PURE__*/ React.createElement("polygon", {
        id: "Yellow-Cutout-Panel",
        transform: "translate(55.500000, 59.000000) scale(-1, -1) rotate(-270.000000) translate(-55.500000, -59.000000) ",
        points: "-3.5 84.9155463 88.6453479 3.5 114.5 3.5 114.5 114.5 -3.5 114.5"
    }))))))), /*#__PURE__*/ React.createElement("svg", {
        width: "30px",
        height: "24px",
        viewBox: "0 0 30 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: clsx("absolute bottom-5 md:bottom-[unset] md:top-9 lg:top-7 right-5 md:right-7 lg:right-5 transition-all", {
            "text-white": color !== "yellow",
            "text-gray-600": color === "yellow"
        })
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-649.000000, -573.000000)",
        stroke: "currentColor",
        strokeWidth: "2.5"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Hero",
        transform: "translate(0.000000, 100.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Promo-Banner",
        transform: "translate(75.000000, 437.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link-Tab",
        transform: "translate(519.000000, -0.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Link/Arrow/Med",
        transform: "translate(54.000000, 33.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.250226,4.39339828 L28.9409609,15 L18.250226,25.6066017 M28.9409609,15 L1.72679283,15",
        id: "Icon"
    })))))))))));
}
